<script setup lang="ts">
import Number1 from "assets/images/YouGet/1.svg";
import Number2 from "assets/images/YouGet/2.svg";
import Number3 from "assets/images/YouGet/3.svg";

const youget = await queryContent('/youget').findOne()

const currentComponent = (index) => {
  switch (index) {
    case 0:
      return Number1
    case 1:
      return Number2
    case 2:
      return Number3
  }
}
</script>

<template>
  <section class="you-get">
    <div class="container">
      <h2 class="you-get__title text-40">
        {{ youget.title }}
      </h2>
      <div class="you-get__items">
        <div v-for="(text, index) in youget.list" :key="index" class="you-get__item">
          <component :is="currentComponent(index)" class="you-get__number" />
          <p class="you-get__description text-20">{{ text }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.you-get {
  padding: 68px 0;
  background-color: var(--bg-grey);

  @media (max-width: $large) {
    padding: 56px 0;
  }

  @media (max-width: $medium) {
    padding: 40px 0;
  }

  @media (max-width: $mobile) {
    padding: 36px 0;
  }

  &__description {
    position: relative;

    @media (max-width: $mobile) {
      max-width: 300px;
    }
  }

  &__items {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 87px;

    @media (max-width: $large) {
      gap: 16px;
    }

    @media (max-width: $mobile) {
      gap: 24px;
      grid-template-columns: 1fr;
    }
  }

  &__item {
    display: flex;
    gap: 21px;
    align-items: center;
    position: relative;

    @media (max-width: $large) {
      gap: 16px;
    }

    @media (max-width: $medium) {
      flex-direction: column;
      align-items: flex-start;
      gap: 24px;
    }

    @media (max-width: $mobile) {
      flex-direction: row;
      align-items: center;
    }
  }

  &__number {
    flex: 0 0 193px;

    @media (max-width: $large) {
      flex: 0 0 136px;
    }

    @media (max-width: $medium) {
      height: 117px;
    }

    @media (max-width: $mobile) {
      height: 104px;
    }
  }

  &__title {
    margin-bottom: 49px;
    color: var(--dark-color);

    @media (max-width: $mobile) {
      margin-bottom: 36px;
    }
  }
}
</style>
